import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import InputWithLabel from '../Form/Input/InputWithLabel';
import api from '../../api';
import ReactDOM from 'react-dom';

const EditServicesPopup = ({ show, onClose, onSave, vendorId, serviceTypeId }) => {
    const [formData, setFormData] = useState({ services: [] });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const fetchVendorData = async () => {
            if (!vendorId) return;
            try {
                const vendorServicesResponse = await api.get(`/vendor/${vendorId}/service-subtypes/`);
                setFormData({ services: vendorServicesResponse.data || [] });
            } catch (error) {
                console.error('Error fetching vendor service subtypes:', error);
            }
        };
        if (show) {
            fetchVendorData();
        }
    }, [vendorId, show]);

    const handleServiceChange = (index, e) => {
        const { name, value } = e.target;
        const updatedServices = formData.services.map((service, i) => {
            if (i === index) {
                return { ...service, [name]: value };
            }
            return service;
        });
        setFormData({ services: updatedServices });
    };

    const handleAddServiceSelect = () => {
        if (!serviceTypeId) {
            console.error("Critical error: serviceTypeId is missing. Cannot add new service.");
            return;
        }
        const newService = {
            subtype_id: null,
            name: '',
            service_type: serviceTypeId
        };
        setFormData(prev => ({ services: [...prev.services, newService] }));
    };

    // --- ИЗМЕНЕНИЕ ЗДЕСЬ ---
    const handleDeleteService = (index) => {
        // Проверяем, является ли эта услуга последней в списке
        if (formData.services.length <= 1) {
            alert('You cannot delete the last service. At least one service is required.'); // Уведомляем пользователя
            return; // Блокируем удаление
        }

        const updatedServices = formData.services.filter((_, i) => i !== index);
        setFormData({ services: updatedServices });
    };

    const validateForm = useCallback(() => {
        // Ваша логика валидации
        return true;
    }, [formData.services]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        onSave(formData.services);
        onClose();
    };

    if (!show) return null;

    return ReactDOM.createPortal(
        <div className="modal visible" id="edit-services">
            <div className="modal__overlay" onClick={onClose}></div>
            <div className="modal__content">
                <button onClick={onClose} className="button no-style close js--close-modal">
                    <img src="/assets/icon--close-CN6QlgAA.svg" alt="Close"/>
                </button>
                <div className="modal__form">
                    <form className="content" onSubmit={handleSubmit}>
                        <h2>Edit Services</h2>

                        {formData.services.map((service, index) => (
                            <React.Fragment key={service.subtype_id || `new-${index}`}>
                                <InputWithLabel
                                    name="name"
                                    value={service.name}
                                    onChange={(e) => handleServiceChange(index, e)}
                                    label="Service Name"
                                    showDelete={true}
                                    onDelete={() => handleDeleteService(index)}
                                    error={errors.services?.[index]?.name}
                                />
                            </React.Fragment>
                        ))}

                        <button
                            className="underline no-style"
                            type="button"
                            onClick={handleAddServiceSelect}
                        >
                            Add New Service
                        </button>
                        <button className="button button-black" type="submit">Save Services</button>
                    </form>
                </div>
            </div>
        </div>,
        document.body
    );
};

EditServicesPopup.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    vendorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    serviceTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default EditServicesPopup;